import React from "react";
import ComponentLoader, { EComponentList } from "../shared/ComponentLoader/ComponentLoader";
import { GetProductCentricNavList, PCNavListItemType, PCNavTitles } from "../../utils/projectUtils";
import "./CertWorkflowApp.scss";
import PublishProvider from "./PublishContext";
import CertWorkflowAppWrapper from "./CertWorkflowAppWrapper";
import { useParams } from "react-router";
import { CWRouteParams } from "../../constants/router";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import ProjectDetailsHeader from "../shared/ProjectDetailsHeader/ProjectDetailsHeader";
import { useQueryClient } from "react-query";
import { IProjectDetails } from "../../interfaces/project";
import { flatMap } from "lodash";
import StatusErrorPage from "../shared/StatusErrorPage/StatusErrorPage";
import { Bullseye, Grid, GridItem, Sidebar, SidebarContent, SidebarPanel } from "@patternfly/react-core";
import ProjectDetailsSidenav from "../shared/ProjectDetailsSidenav/ProjectDetailsSidenav";

const UpdateGraph = ({match}) => (<ComponentLoader componentName={EComponentList.UpdateGraph} match={match}/>);
const ImageList = ({match}) => (<ComponentLoader componentName={EComponentList.ImageList} match={match}/>);
const CertificationTab = ({match}) => (<ComponentLoader componentName={EComponentList.Certifications} match={match}/>);
const RepositoryInfo = ({match}) => (<ComponentLoader componentName={EComponentList.RepositoryInfo} match={match}/>);
const ComponentDetails = ({match}) => (<ComponentLoader componentName={EComponentList.ComponentDetails} match={match}/>);
const ContactInfo = ({match}) => (<ComponentLoader componentName={EComponentList.ContactsInfo} match={match}/>);
const OptionalQualifications = ({match}) => (<ComponentLoader componentName={EComponentList.OptionalQualifications} match={match}/>);
const SecurityTab = ({ match }) => (<ComponentLoader componentName={EComponentList.Security} match={match} />);
const AssociatedProductTab = ({match}) => (<ComponentLoader componentName={EComponentList.AssociatedProduct} match={match} />);

const NavWrapper = ({exact, path, component: Component}) => (
  <Route
    exact={exact}
    path={path}
    render={props => (
      <Component {...props} />
    )}
  />
);

const PCComponentListObj = {
  [PCNavTitles.Images]: ImageList,
  [PCNavTitles.Certification]: CertificationTab,
  [PCNavTitles.UpdateGraph]: UpdateGraph,
  [PCNavTitles.Security]: SecurityTab,
  [PCNavTitles.UpdateGraph]: UpdateGraph,
  [PCNavTitles.RepositoryInformation]: RepositoryInfo,
  [PCNavTitles.ComponentDetails]: ComponentDetails,
  [PCNavTitles.ContactInfo]: ContactInfo,
  [PCNavTitles.OptionalQualifications]: OptionalQualifications,
  [PCNavTitles.AssociatedProduct]: AssociatedProductTab
}
const ComingSoon = () => (
  <Bullseye style={{
    paddingTop: `4em`
  }}>
    COMING SOON!
  </Bullseye>
);
const CertWorkflowAppMain: React.FC<{
  navList: PCNavListItemType[]
}> = ({navList}) => {
  return (<span className='cwf-main'>
    <ProjectDetailsHeader />
    <Grid className="tab-contents-container">
      <GridItem span={10} offset={1}>
        <Sidebar hasGutter={true}>
          <SidebarPanel>
            <ProjectDetailsSidenav navList={navList}/>
          </SidebarPanel>
          <SidebarContent>
            <div className="cwf-main__sidebar-content">
              {
                navList.map((item) => (
                  <NavWrapper
                    key={item.text}
                    exact={item.exact}
                    path={item.route}
                    component={PCComponentListObj?.[item.text] || ComingSoon}
                  />))
              }
            </div>
          </SidebarContent>
        </Sidebar>
      </GridItem>
    </Grid>
  </span>)
}

const CertWorkflowRouter = () => {
  // handles initial routing and 404
  const queryClient = useQueryClient();
  const projectDetails = queryClient.getQueryData<IProjectDetails>(['projectDetails']);
  const params = useParams<CWRouteParams>();
  const navList = GetProductCentricNavList(projectDetails, params);
  const routeList = flatMap(navList, 'route');
  const match = useRouteMatch();
  return (<Switch>
    {navList?.[0]?.path &&
      <Redirect
        exact
        from={`${match.path}`}
        to={navList?.[0]?.path}
      />
    }
    <Route path={routeList} component={() =>  <CertWorkflowAppMain navList={navList} />}/>
    <Route
      render={() => (
        <StatusErrorPage errorStatus={404} />
      )}
    />
  </Switch>)
}
export const CertWorkflowApp = () => (
  <PublishProvider>
    <CertWorkflowAppWrapper>
      <CertWorkflowRouter />
    </CertWorkflowAppWrapper>
  </PublishProvider>
);
